module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/AnnualMaximumDailyPrecipitation/Nagano_AnnualMaximumDailyPrecipitation_MRI_RCP85_End.png";